export const SEARCH_RESULT = "SEARCH_RESULT";
export const SEARCH_RESULT_ARE_LOADING = "SEARCH_RESULT_ARE_LOADING";
